const CustomKachingApp = () => {
  let app = document.querySelector('.main-product-section kaching-bundle');
  let bundles = [];
  const appCustomData = kachingAppCustomBlockData || [];

  const mainFunction = () => {
    const updateUI = () => {
      if (!bundles.length) return;

      bundles.forEach((bundle, index) => {
        const customBundleData = appCustomData[index] || {};

        const barTitle = bundle.querySelector('.kaching-bundles__bar-title');
        const barSubTitle = bundle.querySelector('.kaching-bundles__bar-subtitle');
        const barBadge = bundle.querySelector('.kaching-bundles__bar-most-popular__content');
        const barLabel = bundle.querySelector('.kaching-bundles__bar-label');
        const pricingContainer = bundle.querySelector('.kaching-bundles__bar-pricing');
        const barPrice = bundle.querySelector('.kaching-bundles__bar-price');
        const barComparePrice = bundle.querySelector('.kaching-bundles__bar-full-price');

        if (barLabel && pricingContainer) {
          pricingContainer.appendChild(barLabel);
        }

        if (barTitle && customBundleData.title?.trim()) barTitle.innerText = customBundleData.title;
        if (barSubTitle && customBundleData.subtitle?.trim()) barSubTitle.innerText = customBundleData.subtitle;
        if (barBadge && customBundleData.badgeText?.trim()) barBadge.innerText = customBundleData.badgeText;
        if (barLabel && customBundleData.labelText?.trim()) barLabel.innerText = customBundleData.labelText;
        if (barPrice && customBundleData.price?.trim()) barPrice.innerText = customBundleData.price;
        if (barComparePrice && customBundleData.comparePrice?.trim()) barComparePrice.innerText = customBundleData.comparePrice;
      });
    };

    updateUI();
  }

  const getDOM = () => {
    let tries = 100;

    const interval = setInterval(() => {
      if (tries-- <= 0) {
        clearInterval(interval);
        return;
      }

      app = document.querySelector('.main-product-section kaching-bundle');
      if (!app) return;

      bundles = app.querySelectorAll('.kaching-bundles__bar');
      if (bundles.length === 0) return;

      clearInterval(interval);
      mainFunction();
    }, 100);
  };

  getDOM();
}

document.addEventListener('DOMContentLoaded', CustomKachingApp);
document.addEventListener('shopify:section:load', CustomKachingApp);
document.addEventListener('shopify:section:unload', CustomKachingApp);
document.addEventListener('shopify:section:select', CustomKachingApp);
document.addEventListener('shopify:section:deselect', CustomKachingApp);
document.addEventListener('shopify:block:load', CustomKachingApp);
document.addEventListener('shopify:block:unload', CustomKachingApp);
document.addEventListener('shopify:block:select', CustomKachingApp);
document.addEventListener('shopify:block:deselect', CustomKachingApp);